








import { Vue, Component, Prop } from 'vue-property-decorator'

import 'semantic-ui-css/components/segment.min.css'
import 'semantic-ui-css/components/card.min.css'

interface Stat {
  icon: string,
  name: string,
  value: number,
  diff: number
}

const positiveGradient: string[] = [
  '1abc9c', '1ccaa7', '1fe0ba', '35e3c1', '4be7c8',
  '62eace', '78edd5', '8ff0dc', 'a5f3e3', 'bcf6ea',
  'd2f9f1', 'e9fcf8', 'ffffff'
]

const negativeGradient: string[] = [
  'cc1400', 'e61700', 'ff1a00', 'ff301a', 'ff4733',
  'ff5e4d', 'ff7566', 'ff8c80', 'ffa399', 'ffbab3',
  'ffd1cc', 'ffe8e6', 'ffffff'
]

@Component
export default class SigmaStatistic extends Vue {
  @Prop() readonly stat!: Stat
  iconColor: string|null = 'ffffff'
  activeNumber: number = this.stat.value - this.stat.diff
  baseNumber: number = this.stat.value - this.stat.diff
  numberWithCommas (x: number) {
    let y = x.toString()
    var pattern = /(-?\d+)(\d{3})/
    while (pattern.test(y)) {
      y = y.replace(pattern, '$1,$2')
    }
    return y
  }

  changeColor (color: string, multi: number) {
    const ctx = this
    setTimeout(() => {
      this.iconColor = color
    }, 50 * multi)
  }

  changeNumber (iteration: number, increment: number, delay: number) {
    const ctx = this
    setTimeout(() => {
      ctx.activeNumber = Math.floor(ctx.baseNumber + (iteration * increment))
    }, delay * iteration)
  }

  resetNumber (maxDuration: number) {
    setTimeout(() => {
      this.activeNumber = this.stat.value
    }, maxDuration)
  }

  colorFade () {
    const ctx = this
    let multiplier = 0
    if (this.stat.diff > 0) {
      positiveGradient.forEach((color) => {
        multiplier += 1
        ctx.changeColor(color, multiplier)
      })
    } else if (this.stat.diff < 0) {
      negativeGradient.forEach((color) => {
        multiplier += 1
        ctx.changeColor(color, multiplier)
      })
    }
  }

  animateNumber () {
    const ctx = this
    const maxIterations = 20

    let maxDuration = Math.floor(Math.abs(this.stat.diff) * (666 / 500))
    maxDuration = maxDuration > 1000 ? 1000 : maxDuration

    const increment = this.stat.diff / maxIterations
    const delay = Math.floor(maxDuration / maxIterations)

    let iteration = 0
    while (iteration < maxIterations) {
      this.changeNumber(iteration, increment, delay)
      iteration += 1
    }
    this.resetNumber(maxDuration)
  }

  mounted () {
    this.colorFade()
    this.animateNumber()
  }
}
